import { render } from "./audio-call.vue?vue&type=template&id=eb6686e4"
import script from "./audio-call.vue?vue&type=script&lang=js"
export * from "./audio-call.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__